export type DeploymentEnvironment = 'production' | 'staging' | 'development';

export const DEFAULT_ENVIRONMENT: DeploymentEnvironment = 'production';
